import { Link, NavLink } from "react-router-dom";
import React from "react";
import { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import AppContext from "../Context/Context";
import DragDrop from "../DragDrop/DragDrop";
import axiosAuth from "../Axios/Interceptors";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import { useGlobalState } from "../Context/GlobalStateContext";
import Notification from "./Notification";
import { SanitizeHtml, getAccessSettings } from "../Shared/Utility";
import { NotificationsScreen } from "../Pages/NotificationsScreen";
import NotificationsPreview from "../MyNotifications/NotificationsPreview";
export default function Header() {
  const globalState = useGlobalState();

  const [contactUsReason, setcontactUsReason] = useState([]);
  const [uploadFileList, setUploadFileList] = useState([]);
  const [triggerChild, setTriggerChild] = useState(false);
  const [isOkToGo, setIsOkToGo] = useState(false);
  const [loadingState, setLoadingState] = useState(false);
  const [ShowMenu, SetShowMenu] = useState(false);
  const ShowHideMenu = () => {
    SetShowMenu(true);
  };

  const [ShowContact, SetShowContact] = useState(false);
  const ShowHideContact = () => {
    SetShowContact(!ShowContact);
  };

  const [contactObject, setcontactObject] = useState({
    Name: globalState.LogInUserName,
    Email: "",
    Subject: "",
    Message: "",
    ContactReason: 0,
  });

  const [inputShowHide, setInputShowHide] = useState({
    NV: false,
    AS: false,
    ND: false,
    Training: false,
    Finance: false,
  });

  const [dragDropFeatures, setDragDropFeatures] = useState({
    ObjectID: 0,
    ObjectType: AppContext.FileUploadObjectTypeHeaderData,
    MaxAllowedFiles: 4,
    UploadType: 1,
    FolderName: "Contact",
    PTUploadedFiles: [],
  });

  const [showInputSection, setShowInputSection] = useState(false);
  const [isInputSectionActive, setIsInputSectionActive] = useState(false);

  const [showReportsSection, setShowReportsSection] = useState(false);
  const [isReportsSectionActive, setIsReportsSectionActive] = useState(false);

  //Logout Menu
  const [showLogout, setshowLogout] = useState(false);
  const ShowHideLogoutMenu = () => {
    setshowLogout(!showLogout);
  };

  const [refresh, setRefresh] = useState(false);

  const [ShowFolder, SetShowFolder] = useState(false);
  const ShowHideFolder = () => {
    SetShowFolder(!ShowFolder);
  };

  function handleDragDropCallback(ChildData: any) {
    setUploadFileList(ChildData);
  }

  useEffect(() => {
    // getContactUsPageData();
  }, []);

  function getContactUsPageData() {
    let object = {} as any;
    object.appid = AppContext.App;
    axiosAuth
      .post(AppContext.CommAPI + "api/PTSupport/GetSupportTypeList", object)
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data[0];
          setcontactUsReason(l_response);
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  useEffect(() => {
    //checkValidation(false);
  }, [contactObject]);

  function checkValidation(takeAction: boolean) {
    if (
      contactObject.Name === "" ||
      contactObject.Email === "" ||
      contactObject.Message === "" ||
      contactObject.ContactReason === 0
    ) {
      if (takeAction) {
        globalState.setNotificationObject({
          ShowPopup: true,
          Heading: "Alert",
          Message: "You need to select from all the information to continue.",
        });
        //alert("You need to select from all the information to continue.");
      }
      {
        setIsOkToGo(false);
      }
    } else {
      setIsOkToGo(true);
      if (takeAction) {
        SaveFiles();
      }
    }
  }

  function clearObject() {
    setcontactObject({
      Name: globalState.LogInUserName,
      Email: "",
      Subject: "",
      Message: "",
      ContactReason: 0,
    });
  }

  function SaveFiles() {
    setLoadingState(true);
    if (uploadFileList && uploadFileList.length > 0) {
      let object = {} as any;
      object.typeid = 1;
      object.attachmenttype = dragDropFeatures.ObjectType;
      object.objectid = dragDropFeatures.ObjectID;
      object.applicationid = AppContext.App;
      object.filesdata = uploadFileList;
      axiosAuth
        .post(
          AppContext.FileManegmentAPI + "api/PTAttachment/SaveFilesData",
          object
        )
        .then((response) => {
          if (response.data.Status === 1) {
            setTriggerChild(!triggerChild);
            let l_response = response.data.Data;
            saveConactUsData(l_response);
          } else {
            AppContext.ShowNotification("error", response.data.Message);
          }
        })
        .catch((error) => {
          console.error("There was an error!", error);
        });
    } else {
      saveConactUsData([]);
    }
  }

  function saveConactUsData(p_S3UploadFileList: any) {
    setLoadingState(true);
    let object = {} as any;
    object.appid = AppContext.App;
    object.typeid = 1;
    object.ptsupporttypeid = contactObject.ContactReason;
    object.subject = "";
    object.firstname = SanitizeHtml(contactObject.Name);
    object.email = SanitizeHtml(contactObject.Email);
    object.contact = "";
    object.message = SanitizeHtml(contactObject.Message);
    object.filesdata = p_S3UploadFileList;
    axiosAuth
      .post(AppContext.CommAPI + "api/PTSupport/SupportSubmitData", object)
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data;
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
        clearObject();
        SetShowContact(false);
        setLoadingState(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setLoadingState(false);
      });
  }

  useEffect(() => {
    setRefresh(!refresh);
  }, [AppContext.BPID]);

  useEffect(() => {
    setcontactObject((prevState: any) => ({
      ...prevState,
      Name: globalState.LogInUserName,
    }));
    setRefresh(!refresh);
  }, [globalState.LogInUserName]);

  const location = useLocation();
  useEffect(() => {
    //New Vehicles
  }, [location.pathname]);

  function LogOutUser() {
    window.location =
      "https://www.pfibusinesstools.com/BusinessTools.aspx" as any;
  }

  function getUserLoggedOut() {
    let object = {} as any;
    axiosAuth
      .post(AppContext.AppAuthBaseURL + "api/SiteUser/GetUserLoggedOut", object)
      .then((response) => {})
      .catch((error) => {
        console.error("There was an error!", error);
        setLoadingState(false);
      });
  }

  const [showDashboard, setShowDashboard] = useState(false);
  const [isDashboard, setDashboardActive] = useState(false);
  const [showInput, setShowInput] = useState(false);
  const [isInput, setInputActive] = useState(false);
  const [showAdmin, setShowAdmin] = useState(false);
  const [showReport, setShowReport] = useState(false);
  const [isAdmin, setAdminActive] = useState(false);

  function NotificationCallBack() {
    globalState.setNotificationObject({
      ShowPopup: false,
      Heading: "",
      Message: "",
    });
  }

  const folderRef = useRef<any>(null);
  const userRef = useRef<any>(null);
  const menuRef = useRef<any>(null);

  useEffect(() => {
    // Function to handle outside clicks
    const handleClickOutside = (event: any) => {
      // Check if the click target is outside the component's DOM node
      if (folderRef.current && !folderRef.current.contains(event.target)) {
        SetShowFolder(false);
      }
      if (userRef.current && !userRef.current.contains(event.target)) {
        setshowLogout(false);
      }
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        SetShowMenu(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <>
      <Notification
        NotificationObject={globalState.NotificationObject}
        NotificationCallBack={NotificationCallBack}
      />
      <header className="header">
        {loadingState && <LoadingAnimation />}
        <div className="header--menu__left">
          <div className="header--left__logo">
            <img src="/images/logo-black.png" width="176px" height="40px" />
          </div>
          <div className="header--left__links">
            <span className="demo-app-txt">Demo</span>
          </div>
        </div>
        <div className="header--menu__right">
          <NotificationsPreview
            ObjectIds={""}
            ObjectType={1}
          ></NotificationsPreview>

          <div className="folder-inn" ref={folderRef}>
            <a onClick={ShowHideFolder}>
              <img src="/images/folder.svg" width="25px" height="20" />
            </a>
            {ShowFolder && (
              <div className="floder-links">
                {AppContext.PermittedAppList &&
                  AppContext.PermittedAppList.map(
                    (Item: any, index: number) => (
                      <React.Fragment key={index}>
                        {AppContext.App === Item.AppID ? (
                          <a
                            className={"c-" + (index + 1)}
                            title={Item.AppDescription}
                          >
                            <img
                              src={Item.Img}
                              width="17px"
                              height="15px"
                              alt={Item.AppName}
                            />
                            <span>{Item.AppName}</span>
                          </a>
                        ) : (
                          <a
                            className={"c-" + (index + 1)}
                            title={Item.AppDescription}
                            href={Item.WebURL}
                          >
                            <img
                              src={Item.Img}
                              width="17px"
                              height="15px"
                              alt={Item.AppName}
                            />
                            <span>{Item.AppName}</span>
                          </a>
                        )}
                        <hr />
                      </React.Fragment>
                    )
                  )}
              </div>
            )}
          </div>
          <a
            onClick={() => {
              getContactUsPageData();
              ShowHideContact();
            }}
          >
            <img src="/images/help.svg" width="24px" height="24" />
          </a>
          {/* <a>
            <img src="/images/envelope.svg" width="32px" height="" />
          </a> */}
          <div className="log-drop" ref={userRef}>
            <a className="log-drop-a" onClick={ShowHideLogoutMenu}>
              <img
                src={globalState.LogInUserImage}
                width="29px"
                height=""
                onError={({ currentTarget }) => {
                  currentTarget.onerror = null;
                  currentTarget.src = "/images/dummyuser.svg";
                }}
              />
              <span>{globalState.LogInUserName}</span>
            </a>
            {showLogout && (
              <div className="logout-menu">
                <div className="log-user-image">
                  <img
                    src={globalState.LogInUserImage}
                    width="29px"
                    height=""
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null;
                      currentTarget.src = "/images/dummyuser.svg";
                    }}
                  />
                </div>
                <div className="setting-log">
                  <a></a>
                  <a href={AppContext.AuthWebLink + "?lgo=1"}>Sign out</a>
                </div>
              </div>
            )}
          </div>
        </div>
      </header>
      <menu
        ref={menuRef}
        className={`${ShowMenu ? "menu hover" : "menu"}`}
        onClick={() => (ShowMenu ? "" : ShowHideMenu())}
      >
        <div className="sub--menu--main">
          {(getAccessSettings(2, 1) > 0 ||
            getAccessSettings(2, 2) > 0 ||
            getAccessSettings(2, 3) > 0 ||
            getAccessSettings(2, 4) > 0 ||
            getAccessSettings(2, 5) > 0 ||
            getAccessSettings(2, 6) > 0 ||
            getAccessSettings(2, 7) > 0) && (
            <>
              <div className="subMenu">
                <a
                  className={`${isInput === true ? "active" : ""}`}
                  onClick={() => setShowInput(!showInput)}
                >
                  <div className="lm-img" title="Programs">
                    <img src="/images/lm3.svg" width="30px" height="30px" />
                  </div>
                  <span className="lm-spn">Programs</span>
                  {showInput && (
                    <span className="open--arrow rotate--deg">&#8250;</span>
                  )}
                  {!showInput && <span className="open--arrow">&#8250;</span>}
                </a>
              </div>
              {showInput && (
                <div className="menu-close">
                  {getAccessSettings(2, 1) > 0 &&
                    globalState.AppAccessLevelData.DID == 0 && (
                      <div
                        className="subMenu"
                        onClick={() => SetShowMenu(false)}
                      >
                        <NavLink
                          to={"programdashboard"}
                          className={({ isActive }) =>
                            isActive ? "active" : ""
                          }
                        >
                          VRM Programs
                        </NavLink>
                      </div>
                    )}
                  {getAccessSettings(2, 29) > 0 &&
                    globalState.AppAccessLevelData.DID == 0 && (
                      <div
                        className="subMenu"
                        onClick={() => SetShowMenu(false)}
                      >
                        <NavLink
                          to={"programoverview"}
                          className={({ isActive }) =>
                            isActive ? "active" : ""
                          }
                        >
                          Program Overview
                        </NavLink>
                      </div>
                    )}
                  {getAccessSettings(2, 32) > 0 &&
                    globalState.AppAccessLevelData.DID == 0 && (
                      <div
                        className="subMenu"
                        onClick={() => SetShowMenu(false)}
                      >
                        <NavLink
                          to={"programstatus"}
                          className={({ isActive }) =>
                            isActive ? "active" : ""
                          }
                        >
                          Program Status
                        </NavLink>
                      </div>
                    )}
                  {/* {getAccessSettings(2, 2) > 0 &&
                    globalState.AppAccessLevelData.DID == 0 && (
                      <div
                        className="subMenu"
                        onClick={() => SetShowMenu(false)}
                      >
                        <NavLink
                          to={"programapproval"}
                          className={({ isActive }) =>
                            isActive ? "active" : ""
                          }
                        >
                          Program Approval
                        </NavLink>
                      </div>
                    )} */}
                  {getAccessSettings(2, 3) > 0 && (
                    <div className="subMenu" onClick={() => SetShowMenu(false)}>
                      <NavLink
                        to={"scorecard"}
                        className={({ isActive }) => (isActive ? "active" : "")}
                      >
                        Scorecards
                      </NavLink>
                    </div>
                  )}
                  {getAccessSettings(2, 4) > 0 &&
                    globalState.AppAccessLevelData.DID == 0 && (
                      <div
                        className="subMenu"
                        onClick={() => SetShowMenu(false)}
                      >
                        <NavLink
                          to={"bulkinput?tid=1"}
                          className={({ isActive }) =>
                            isActive ? "active" : ""
                          }
                        >
                          Targets & Actuals
                        </NavLink>
                      </div>
                    )}
                  {getAccessSettings(2, 5) > 0 &&
                    globalState.AppAccessLevelData.DID == 0 && (
                      <div
                        className="subMenu"
                        onClick={() => SetShowMenu(false)}
                      >
                        <NavLink
                          to={"exceptions"}
                          className={({ isActive }) =>
                            isActive ? "active" : ""
                          }
                        >
                          Exceptions Status
                        </NavLink>
                      </div>
                    )}
                  {getAccessSettings(2, 6) > 0 &&
                    globalState.AppAccessLevelData.DID == 0 && (
                      <div
                        className="subMenu"
                        onClick={() => SetShowMenu(false)}
                      >
                        <NavLink
                          to={"conditionalholdapproval"}
                          className={({ isActive }) =>
                            isActive ? "active" : ""
                          }
                        >
                          Conditional Hold Status
                        </NavLink>
                      </div>
                    )}
                  {getAccessSettings(2, 7) > 0 &&
                    globalState.AppAccessLevelData.DID == 0 && (
                      <div
                        className="subMenu"
                        onClick={() => SetShowMenu(false)}
                      >
                        <NavLink
                          to={"reinvestment"}
                          className={({ isActive }) =>
                            isActive ? "active" : ""
                          }
                        >
                          Re-Investment Requests
                        </NavLink>
                      </div>
                    )}
                </div>
              )}
            </>
          )}
          {(getAccessSettings(2, 8) > 0 ||
            getAccessSettings(2, 9) > 0 ||
            getAccessSettings(2, 10) > 0 ||
            getAccessSettings(2, 11) > 0 ||
            getAccessSettings(2, 12) > 0 ||
            getAccessSettings(2, 13) > 0 ||
            getAccessSettings(2, 14) > 0) && (
            <>
              <div className="subMenu">
                <a
                  className={`${isDashboard === true ? "active" : ""}`}
                  onClick={() => setShowDashboard(!showDashboard)}
                >
                  <div className="lm-img" title="Finance">
                    <img src="/images/lm1.svg" width="26px" height="26px" />
                  </div>
                  <span className="lm-spn">Finance</span>
                  {showDashboard && (
                    <span className="open--arrow rotate--deg">&#8250;</span>
                  )}
                  {!showDashboard && (
                    <span className="open--arrow">&#8250;</span>
                  )}
                </a>
              </div>
              {showDashboard && (
                <div className="menu-close">
                  {globalState.AppAccessLevelData.DID == 0 &&
                    getAccessSettings(2, 8) > 0 && (
                      <div
                        className="subMenu"
                        onClick={() => SetShowMenu(false)}
                      >
                        <NavLink
                          to={"ibbformulaselection"}
                          className={({ isActive }) =>
                            isActive ? "active" : ""
                          }
                        >
                          VRM Importer Formula
                        </NavLink>
                      </div>
                    )}
                  {getAccessSettings(2, 9) > 0 &&
                    globalState.AppAccessLevelData.DID == 0 && (
                      <div
                        className="subMenu"
                        onClick={() => SetShowMenu(false)}
                      >
                        <NavLink
                          to={"copa"}
                          className={({ isActive }) =>
                            isActive ? "active" : ""
                          }
                        >
                          COPA
                        </NavLink>
                      </div>
                    )}
                  {getAccessSettings(2, 10) > 0 && (
                    <div className="subMenu" onClick={() => SetShowMenu(false)}>
                      <NavLink
                        to={"copainvoicesdata"}
                        className={({ isActive }) => (isActive ? "active" : "")}
                      >
                        Quarterly Invoiced Vehicles
                      </NavLink>
                    </div>
                  )}
                  {getAccessSettings(2, 11) > 0 && (
                    <div className="subMenu" onClick={() => SetShowMenu(false)}>
                      <NavLink
                        to={"invoicesdata"}
                        className={({ isActive }) => (isActive ? "active" : "")}
                      >
                        Quarterly VRM Invoices
                      </NavLink>
                    </div>
                  )}
                  {getAccessSettings(2, 12) > 0 &&
                    globalState.AppAccessLevelData.DID == 0 && (
                      <div
                        className="subMenu"
                        onClick={() => SetShowMenu(false)}
                      >
                        <NavLink
                          to={"creditnotesdata"}
                          className={({ isActive }) =>
                            isActive ? "active" : ""
                          }
                        >
                          Internal Credit Note Request
                        </NavLink>
                      </div>
                    )}
                  {getAccessSettings(2, 13) > 0 &&
                    globalState.AppAccessLevelData.DID == 0 && (
                      <div
                        className="subMenu"
                        onClick={() => SetShowMenu(false)}
                      >
                        <NavLink
                          to={"creditnotesapproval"}
                          className={({ isActive }) =>
                            isActive ? "active" : ""
                          }
                        >
                          Internal Credit Note Request Approval
                        </NavLink>
                      </div>
                    )}
                  {getAccessSettings(2, 14) > 0 &&
                    globalState.AppAccessLevelData.DID == 0 && (
                      <div
                        className="subMenu"
                        onClick={() => SetShowMenu(false)}
                      >
                        <NavLink
                          to={"paymentcriteria"}
                          className={({ isActive }) =>
                            isActive ? "active" : ""
                          }
                        >
                          Payment Criteria
                        </NavLink>
                      </div>
                    )}
                </div>
              )}
            </>
          )}
          {(getAccessSettings(2, 15) > 0 ||
            getAccessSettings(2, 16) > 0 ||
            getAccessSettings(2, 17) > 0 ||
            getAccessSettings(2, 31) > 0) && (
            <>
              <div className="subMenu">
                <a
                  className={`${isDashboard === true ? "active" : ""}`}
                  onClick={() => setShowReport(!showReport)}
                >
                  <div className="lm-img" title="Report">
                    <img src="/images/report.svg" width="30px" height="30px" />
                  </div>
                  <span className="lm-spn">Report</span>
                  {showReport && (
                    <span className="open--arrow rotate--deg">&#8250;</span>
                  )}
                  {!showReport && <span className="open--arrow">&#8250;</span>}
                </a>
              </div>
              {showReport && (
                <>
                  <div className="menu-close">
                    {getAccessSettings(2, 15) > 0 && (
                      <div
                        className="subMenu"
                        onClick={() => SetShowMenu(false)}
                      >
                        <NavLink
                          to={"exceptionhistory"}
                          className={({ isActive }) =>
                            isActive ? "active" : ""
                          }
                        >
                          Exceptions History
                        </NavLink>
                      </div>
                    )}

                    {getAccessSettings(2, 16) > 0 && (
                      <div
                        className="subMenu"
                        onClick={() => SetShowMenu(false)}
                      >
                        <NavLink
                          to={"conditionalholdhistory"}
                          className={({ isActive }) =>
                            isActive ? "active" : ""
                          }
                        >
                          Conditional Hold History
                        </NavLink>
                      </div>
                    )}
                    {getAccessSettings(2, 17) > 0 &&
                      globalState.AppAccessLevelData.DID == 0 && (
                        <div
                          className="subMenu"
                          onClick={() => SetShowMenu(false)}
                        >
                          <NavLink
                            to={"reinvestmentapproval"}
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            Re-Investment Summary
                          </NavLink>
                        </div>
                      )}
                    {getAccessSettings(2, 31) > 0 &&
                      globalState.AppAccessLevelData.DID == 0 && (
                        <div
                          className="subMenu"
                          onClick={() => SetShowMenu(false)}
                        >
                          <NavLink
                            to={"achievementstatusreport"}
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            Achievement Status Report
                          </NavLink>
                        </div>
                      )}
                  </div>
                </>
              )}
            </>
          )}

          {/* {globalState.ManageAdmin &&
            (getAccessSettings(2, 18) > 0 ||
              getAccessSettings(2, 19) > 0 ||
              getAccessSettings(2, 20) > 0 ||
              getAccessSettings(2, 21) > 0 ||
              getAccessSettings(2, 22) > 0 ||
              getAccessSettings(2, 23) > 0 ||
              getAccessSettings(2, 24) > 0 ||
              getAccessSettings(2, 25) > 0) && (
              <>
                <div className="subMenu">
                  <a
                    className={`${isDashboard === true ? "active" : ""}`}
                    onClick={() => setShowAdmin(!showAdmin)}
                  >
                    <div className="lm-img" title="Programs Management">
                      <img src="/images/lm4.svg" width="30px" height="30px" />
                    </div>
                    <span className="lm-spn">Programs Management</span>
                    {showAdmin && (
                      <span className="open--arrow rotate--deg">&#8250;</span>
                    )}
                    {!showAdmin && <span className="open--arrow">&#8250;</span>}
                  </a>
                </div>
                {showAdmin && (
                  <>
                    <div className="menu-close">
                      {getAccessSettings(2, 18) > 0 && (
                        <div
                          className="subMenu"
                          onClick={() => SetShowMenu(false)}
                        >
                          <NavLink
                            to={"programlist"}
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            Programs Creation
                          </NavLink>
                        </div>
                      )}
                      {getAccessSettings(2, 19) > 0 && (
                        <div
                          className="subMenu"
                          onClick={() => SetShowMenu(false)}
                        >
                          <NavLink
                            to={"approvalsettings"}
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            Approval Settings
                          </NavLink>
                        </div>
                      )}
                      {getAccessSettings(2, 20) > 0 && (
                        <div
                          className="subMenu"
                          onClick={() => SetShowMenu(false)}
                        >
                          <NavLink
                            to={"grouplist"}
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            MENA Sub-regions
                          </NavLink>
                        </div>
                      )}
                      {getAccessSettings(2, 21) > 0 && (
                        <div
                          className="subMenu"
                          onClick={() => SetShowMenu(false)}
                        >
                          <NavLink
                            to={"functionalarea"}
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            Functional Area
                          </NavLink>
                        </div>
                      )}
                      {getAccessSettings(2, 22) > 0 && (
                        <div
                          className="subMenu"
                          onClick={() => SetShowMenu(false)}
                        >
                          <NavLink
                            to={"importersettings"}
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            Importer Settings
                          </NavLink>
                        </div>
                      )}
                      {getAccessSettings(2, 23) > 0 && (
                        <div
                          className="subMenu"
                          onClick={() => SetShowMenu(false)}
                        >
                          <NavLink
                            to={"useraccesslevel"}
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            User Access Management
                          </NavLink>
                        </div>
                      )}
                      {getAccessSettings(2, 24) > 0 && (
                        <div
                          className="subMenu"
                          onClick={() => SetShowMenu(false)}
                        >
                          <NavLink
                            to={"emailtemplates"}
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            Email Templates
                          </NavLink>
                        </div>
                      )}
                      {getAccessSettings(2, 25) > 0 && (
                        <div
                          className="subMenu"
                          onClick={() => SetShowMenu(false)}
                        >
                          <NavLink
                            to={"deadlinemanagement"}
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            Deadline Management
                          </NavLink>
                        </div>
                      )}
                      {getAccessSettings(2, 25) > 0 && (
                        <div
                          className="subMenu"
                          onClick={() => SetShowMenu(false)}
                        >
                          <NavLink
                            to={"triggers"}
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            Triggers
                          </NavLink>
                        </div>
                      )}
                    </div>
                  </>
                )}
              </>
            )} */}
        </div>
      </menu>
      {ShowContact && (
        <div className="popup-help">
          <div className="help-popup-display">
            <div className="help-inner">
              <div className="help-head">
                <h3>Contact Support</h3>
                <a className="close-help" onClick={ShowHideContact}>
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>
              <div className="help-row">
                <p>Name:</p>
                <input
                  value={contactObject.Name}
                  onChange={(e) =>
                    setcontactObject((prevState: any) => ({
                      ...prevState,
                      Name: e.target.value,
                    }))
                  }
                  placeholder="your name"
                  type="text"
                />
              </div>
              <div className="help-row">
                <p>Email:</p>
                <input
                  value={contactObject.Email}
                  onChange={(e) =>
                    setcontactObject((prevState: any) => ({
                      ...prevState,
                      Email: e.target.value,
                    }))
                  }
                  placeholder="your email address"
                  type="text"
                />
              </div>
              {/* <div className="help-row">
              <p>Subject:</p>
              <input
                value={contactObject.Subject}
                onChange={(e) =>
                  setcontactObject((prevState: any) => ({
                    ...prevState,
                    Subject: e.target.value,
                  }))
                }
                placeholder="Subject"
                type="text"
              />
            </div> */}
              <div className="help-row">
                <p>Type:</p>
                <select
                  className="input-field select-field"
                  defaultValue={contactObject.ContactReason}
                  onChange={(e) =>
                    setcontactObject((prevState: any) => ({
                      ...prevState,
                      ContactReason: e.target.value,
                    }))
                  }
                >
                  <option value="">Select</option>
                  {contactUsReason &&
                    contactUsReason.map((Item: any, index) => (
                      <option
                        value={Item.PTSupportTypeID}
                        key={Item.PTSupportTypeID}
                      >
                        {Item.Name}
                      </option>
                    ))}
                </select>
              </div>
              <div className="help-row help-area">
                <p>Message:</p>
                <textarea
                  value={contactObject.Message}
                  onChange={(e) =>
                    setcontactObject((prevState: any) => ({
                      ...prevState,
                      Message: e.target.value,
                    }))
                  }
                  placeholder="type your message..."
                ></textarea>
              </div>
              <div className="help-row help-area flex-start">
                <p>File/Image:</p>
                <div className="drad-drop">
                  <DragDrop
                    ParentFeatures={dragDropFeatures}
                    DragDropCallback={handleDragDropCallback}
                    TriggerChild={triggerChild}
                  />
                </div>
              </div>
              <div className="help-btns">
                <a onClick={() => checkValidation(true)}>Submit</a>
                <a onClick={ShowHideContact}>Cancel</a>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
